import styled from 'styled-components'

export const AddRecruiterFormNameAndSurnameContainer = styled.div``
